/**
 * Imports Module Routes
 *
 * Route definitions for the Imports module.
 * - /imports          → Data Import landing page (history + "Import Data" button)
 * - /imports/new      → Generic wizard with type selection as Step 0
 * - /imports/:type    → Domain-specific wizard (skips type selection)
 * - /imports/:id      → Import detail view
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/imports',
        component: ModuleLayout,
        meta: {
            moduleKey: 'settings.data_import',
        },
        children: [
            {
                path: '',
                name: 'imports-history',
                component: () => import('./views/ImportHistory.vue'),
                meta: {
                    title: 'Data Import',
                },
            },
            {
                path: 'new',
                name: 'imports-new',
                component: () => import('./views/GenericImportWizard.vue'),
                meta: {
                    title: 'Import Data',
                },
            },
            {
                path: 'properties',
                name: 'imports-properties',
                component: () => import('./views/PropertyImportWizard.vue'),
                meta: {
                    title: 'Import Properties',
                },
            },
            {
                path: 'products',
                name: 'imports-products',
                component: () => import('./views/ProductImportWizard.vue'),
                meta: {
                    title: 'Import Products',
                },
            },
            {
                path: 'material-presets',
                name: 'imports-material-presets',
                component: () => import('./views/MaterialPresetImportWizard.vue'),
                meta: {
                    title: 'Import Material Presets',
                },
            },
            {
                path: 'fab-schedule',
                name: 'imports-fab-schedule',
                component: () => import('./views/FabScheduleImportWizard.vue'),
                meta: {
                    title: 'Import Fab Schedule',
                },
            },
            {
                path: ':id',
                name: 'imports-detail',
                component: () => import('./views/ImportDetail.vue'),
                meta: {
                    title: 'Import Details',
                },
            },
        ],
    },
]

export default routes
